import React from 'react';

import { useTranslation } from 'react-i18next';

import { AmazonS3Buckets } from 'lane-shared/config';
import {
  AttachmentDocumentContentTypeEnum,
  AttachmentImageContentTypeEnum,
  AttachmentResponse,
  AttachmentVariantEnum,
} from 'lane-shared/types/attachment';
import { convertToUUID } from 'uuid-encoding';

import { AddAttachment, Flex } from 'components';
import { H4 } from 'components/typography';

import styles from '../index.scss';

type TaskAttachmentsProps = {
  taskId: string;
  canAddAttachments: boolean;
  canDeleteAttachments: boolean;
  onAttachmentCreated: (attachments: AttachmentResponse[]) => Promise<void>;
  onAttachmentDeleted: (attachmentId: string) => Promise<void>;
};

export function TaskAttachments({
  taskId,
  canAddAttachments,
  canDeleteAttachments,
  onAttachmentCreated,
  onAttachmentDeleted,
}: TaskAttachmentsProps) {
  const { t } = useTranslation();

  return (
    <Flex className={styles.TaskDetailsBlock} width="full" direction="column">
      <Flex direction="column">
        <H4 mb={4} mt={2}>
          {t`web.admin.workOrder.preventiveMaintenance.task.attachments.title`}
        </H4>
        <AddAttachment
          entityId={convertToUUID(taskId)}
          entityType="PMTask"
          editMode={false}
          variant={AttachmentVariantEnum.WorkOrder}
          afterAttachmentCreated={onAttachmentCreated}
          afterAttachmentDeleted={onAttachmentDeleted}
          canAddAttachments={canAddAttachments}
          preventDelete={!canDeleteAttachments}
          acceptedFileTypes={[
            ...Object.values(AttachmentImageContentTypeEnum),
            AttachmentDocumentContentTypeEnum.pdf,
          ]}
          s3Bucket={AmazonS3Buckets.Activate}
        />
      </Flex>
    </Flex>
  );
}
